import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Constants} from './constants-service'
import { ErrorHandlerService } from './error.handler.service';
import 'rxjs/Rx';
import {CurrentUser, Tokens} from '../models/user';

@Injectable()
export class AuthenticationService {

    constructor(private http: HttpClient, private consts: Constants, private errHand: ErrorHandlerService) { }
    login(username: string, password: string): Observable<boolean> {

        const headers = new HttpHeaders()
          .append('Content-Type', 'application/x-www-form-urlencoded')
          .append('Authorization', 'Basic ' + btoa(username + ':' + password));
        return this.http.get(this.consts.loginSet + '/api/login', { headers: headers })
            .map((responce: CurrentUser) => {
                if (responce.success) {
                    sessionStorage.setItem('currentUser',
                      JSON.stringify({username: responce.user.fullName, role: responce.user.role}));
                    sessionStorage.setItem('currentTokens',
                      JSON.stringify({tokens: responce.tokens}));
                      return true;
                } else {
                      return false;
                }
            })
          .catch(error => this.errHand.handlerEror(error));
    }
    logout(): void {
                  sessionStorage.removeItem('currentUser');
                  sessionStorage.removeItem('currentTokens');
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/services/authentication-services.ts